import { BaseModel } from './BaseModel';

export interface AnnouncementTargetLocation {
    id?: number;
    short: string;
    long: string;
}

export interface AnnouncementTargetNode {
    id: number;
    name: string;
}

export interface AnnouncementTargetEgg {
    id?: number;
    identifier: string;
    name: string;
    tag?: string | null;
    nestId?: number;
}

export interface AnnouncementTargetTag {
    id: string;
    name: string;
    slug: string;
}

export interface AnnouncementTargets {
    locations: AnnouncementTargetLocation[];
    nodes: AnnouncementTargetNode[];
    eggs: AnnouncementTargetEgg[];
    tags: AnnouncementTargetTag[];
}

export interface AnnouncementAffectedServer {
    uuidShort: string;
    name: string;
}

export interface AnnouncementAffectedServers {
    total: number;
    servers: AnnouncementAffectedServer[];
}

export class Announcement extends BaseModel {
    public id = -1;
    public type = '';
    public icon: string | null = null;
    public text = '';
    public displayAtTop = false;
    public updatedAt = '';
    public targets: AnnouncementTargets = {
        locations: [],
        nodes: [],
        eggs: [],
        tags: [],
    };
    public affectedServers: AnnouncementAffectedServers | null = null;

    // Admin only props
    public active = false;
    public createdAt = '';
}
